<template>
  <settings-modal
    class="operation-fee-return-modal t-operation-fee-return-modal"
    hide-container
  >
    <template slot="heading">Return fee for payment {{ payment.id }}?</template>

    <scrollable-container slot="raw">
      <div>
        <data-row>
          <v-flex>
            <one-data-column :data-props="{ style: 'min-width: auto' }">
              <data-label slot="label">Fee amount</data-label>
              <div class="t-fee-amount">{{ transactions[0].transaction.amount | number }} {{ transactions[0].transaction.currency }}</div>
            </one-data-column>

            <template v-if="isCommentRequired">
              <one-data-column
                :label-props="{ style: 'display: none;' }"
                :data-props="{ style: 'min-width: auto' }"
              >
                <v-select
                  v-model="form.commentTemplate"
                  class="t-comment-template-field"
                  :items="commentTemplateOptions"
                  label="Comment template"
                  @change="onCommentTemplateChange"
                />
              </one-data-column>

              <one-data-column
                :label-props="{ style: 'display: none;' }"
                :data-props="{ style: 'min-width: auto' }"
              >
                <v-textarea
                  v-model="form.comment"
                  max-length="1000"
                  class="t-comment-field"
                  label="Comment"
                  :counter="1000"
                  hint="Required field"
                  persistent-hint
                  :error-messages="getValidationErrorMessage('comment')"
                />
              </one-data-column>
            </template>
          </v-flex>
        </data-row>

        <error-alert :error="error" />
      </div>
    </scrollable-container>

    <template slot="actions">
      <v-btn
        class="t-return-card"
        color="primary"
        medium
        flat
        :disabled="!isFormFilled || loading"
        @click="onReturnFeeButtonClick"
      >return fee</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_OPERATION_UPDATE } from '@/events/operations'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import PaymentApi from '@/services/Api/PaymentApi'

  // Mixins
  import form from '@/mixins/form'

  // Components
  import SettingsModal from '@/components/modals/SettingsModal'
  import ScrollableContainer from '@/components/ui/ScrollableContainer'
  import DataRow from '@/components/ui/Data/DataRow'
  import OneDataColumn from '@/components/ui/Data/OneDataColumn'
  import DataLabel from '@/components/ui/Data/DataLabel'
  import ErrorAlert from '@/components/ui/ErrorAlert'

  export default {
    name: 'FeeOperationReturnModal',
    components: {
      SettingsModal,
      ScrollableContainer,
      DataRow,
      OneDataColumn,
      DataLabel,
      ErrorAlert
    },
    mixins: [form],
    data () {
      return {
        form: { commentTemplate: null, comment: null },
        feeOperationReturnApiRequest: new ApiRequest(PaymentApi.returnFeeOperation)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      isCommentRequired () {
        return this.isFieldRequired('comment')
      },
      payment () {
        return this.modal.data.payment
      },
      operation () {
        return this.modal.data.operation
      },
      transactions () {
        return this.modal.data.transactions
      },
      requiredFields () {
        if (!this.operation.isDone) {
          return []
        }

        return ['comment']
      },
      commentTemplateOptions () {
        return [
          'Fee return for payment ' + this.payment.id,
          'Maintenance fee return',
          'GBP account maintenance fee return',
          'Fee return for holding funds on a Current Account',
          'Card related fee return',
          'Card issuing fee return',
          'Card delivery fee return',
          'Monthly fee return for card',
          'Currency conversion markup return',
          'Inactivity fee return'
        ]
      },
      loading () {
        return this.feeOperationReturnApiRequest.loading
      },
      error () {
        return this.feeOperationReturnApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onCommentTemplateChange (value) {
        this.setCommentField(value)
      },
      onReturnFeeButtonClick () {
        this.returnFee()
          .then(() => {
            this.$eventHub.$emit(EVENT_OPERATION_UPDATE)
            this.closeModal()

            setTimeout(() => {
              this.showModal({
                name: 'SuccessFlashModal',
                data: { message: 'Fee has been successfully returned.' }
              })
            }, 100)
          })
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      setCommentField (comment) {
        this.$set(this.form, 'comment', comment)
      },
      returnFee () {
        return this.feeOperationReturnApiRequest.execute(
          this.payment.id,
          this.operation.id,
          this.form.comment
        )
      }
    }
  }
</script>
